exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "video {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    z-index: -100;\n    -webkit-transform: translateX(-50%) translateY(-50%);\n            transform: translateX(-50%) translateY(-50%);\n    background: url(" + require("../../../assets/images/login/bg.png") + ") no-repeat;\n    background-size: cover;\n    transition: 1s opacity;\n}\n\n.rowBody {\n    position: fixed;\n    /* width: 100%; */\n    top: 0px;\n    right: 0;\n    left: 0;\n    height: 100%;\n    background-color: rgba(14, 46, 71, 0.8) !important;\n    overflow-y: auto;\n    color: white;\n    overflow: hidden;\n    overflow-y: scroll;\n}\n\n.custmNav {\n    padding-right: 7%;\n}\n\n.nav>li>a {\n    color: white !important;\n    background-color: transparent;\n}\n\n.nav>li>a:focus,\n.nav>li>a:hover {\n    color: #00A8c6;\n    background-color: transparent;\n}\n\n.links a,\n.links a:focus {\n    text-decoration: none;\n}\n\n.links img {\n    width: 15%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/pages/app-download/app-download.component.css
// module id = ../../../../../src/app/pages/app-download/app-download.component.css
// module chunks = main